// extracted by mini-css-extract-plugin
export default {"wrap":"AH-z","fullWidth":"BH-z","hideOnDesktop":"CH-z","content":"DH-z","hasOpenedNav":"EH-z","crumbsList":"FH-z","dropdownsWrap":"GH-z"};